var CoreObject = require("enyo/CoreObject"),
    kind       = require("enyo/kind"),
    logger     = require("enyo/logger");

require("enyo-ui");

/**
 * An abstract DataAdapter for [Repeater]{@link enyo-ui.Repeater} controls. This
 * abstract defines some required methods and some common functionality.
 *
 * This class is not meant to be used directly, but rather to be extended to
 * implement an adapter for a particular data format.
 *
 * @class enyo-ui.RepeaterDataAdapter
 * @abstract
 * @public
 */
module.exports = kind(/** @lends enyo-ui.RepeaterDataAdapter */ {

    /**
     * @private
     */
    name: "enyo-ui.RepeaterDataAdapter",

    /**
     * @private
     */
    kind: CoreObject,

    /**
     * Sets reference to repeater and observes the repeater's dataset.
     *
     * @param {enyo.Control}  repeater  The repeater
     * @private
     */
    constructor: function(repeater) {
        this.repeater = repeater;
        repeater.observe("data", this.dataChanged, this);
        this.dataChanged();
    },

    /**
     * Respond to changes in the dataset.
     *
     * @param {Array}  previous  The previous array
     * @public
     */
    dataChanged: function() {
        logger.error("RepeaterDataAdapter must implement a `dataChanged` method");
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param  {number}  index  The index
     * @return {*}       The record, or `null` if not found.
     * @public
     */
    getRecordByIndex: function() {
        return logger.error("RepeaterDataAdapter must implement a `getRecordByIndex` method");
    },

    /**
     * Gets a record from the dataset by index.
     *
     * @param  {*}       record  The record
     * @return {number}  The index, or `null` if not found.
     * @public
     */
    getIndexByRecord: function() {
        return logger.error("RepeaterDataAdapter must implement a `getIndexByRecord` method");
    },

    /**
     * Gets a unique identifier for the record.
     *
     * @param  {*}       record  The record
     * @return {string}  The record uid.
     * @public
     */
    getRecordUid: function() {
        return logger.error("RepeaterDataAdapter must implement a `getRecordUid` method");
    },

    /**
     * This method only here to satisfy the repeater api. Because any data
     * change will trigger a complete re-draw we don't actually need to update
     * any children.
     *
     * @param  {enyo.Control}  child   The child
     * @return {enyo.Control}  The created child
     * @public
     */
    updateChild: function() {
        return logger.error("RepeaterDataAdapter must implement a `updateChild` method");
    }

});
